import { j as e } from "./jsx-runtime-3tyXYecC.mjs";
import { B as r } from "./body-text-BiQwh5-U.mjs";
import { F as a } from "./flex-Cc3osQLf.mjs";
function c({ name: o, value: i, description: l, size: n }) {
  return /* @__PURE__ */ e.jsxs(a, { "data-fabric-component": "NameValuePair", flexDirection: "column", gap: 0.25, children: [
    /* @__PURE__ */ e.jsxs(a, { flexDirection: "column", gap: 0.5, children: [
      /* @__PURE__ */ e.jsx(r, { color: "neutral-weak", size: "small", children: o }),
      /* @__PURE__ */ e.jsx(r, { color: "neutral-extra-strong", size: n, weight: "medium", children: i })
    ] }),
    l ? /* @__PURE__ */ e.jsx(r, { color: "neutral-weak", size: "small", children: l }) : null
  ] });
}
export {
  c as N
};
//# sourceMappingURL=name-value-pair-C2hGQuWa.mjs.map
